/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-hidden";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";
export const localeOptions = [
  { id: "th", name: "THAI", direction: "ltr" },
  { id: "en", name: "English", direction: "ltr" }
];

export const firebaseConfig = {
  apiKey: "AIzaSyBrMALV31bcs20yxaka6HmMh0UFVtNJT4o",
  authDomain: "tpchannel10-13571.firebaseapp.com",
  databaseURL: "https://gogo-react-login.firebaseio.com",
  projectId: "tpchannel10-13571",
  storageBucket: "tpchannel10-13571.appspot.com",
  messagingSenderId: "542107908035"
};

export const searchPath = "/app/pages/search";
export const servicePath = "https://api.coloredstrategies.com";

/*
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const isMultiColorActive = true;
export const defaultColor = "dark.blue";
export const defaultDirection = "ltr";
export const isDarkSwitchActive = true;
export const themeColorStorageKey = "__theme_color";
export const themeRadiusStorageKey = "__theme_radius";
export const isDemo = false;
